<template>
    <div class="row mx-0">
      <relationship-management v-if="showRelationshipManagement" :relationshipProp="relationship" @hideRelationshipManagement="hideRelationshipManagement"/> 
        <div class="col-md-12 main-content">
            <h1 class="first-header heading-large"><i class="fas fa-users mr-2"></i>Manage Customers</h1>
            <div 
                class="table-container card"
            >
                <div class="table-title">
                    <input class="search-bar no-focus" 
                        :class="!$breakpoint.smAndDown ? 'w-25' : 'w-100'"
                        v-model="searchInput"
                        type="search"
                        placeholder="Search customers">
                </div>
                <div v-if="buyers.length < 1" 
                    class="w-100 alert alert-secondary mt-3 text-center">
                    <i class="fas fa-info-circle mr-2"></i>No customers found
                </div>     
                <table v-else class="table responsive-table">
                    <thead>
                        <tr>
                            <th>
                                Customer
                                <span v-if="selectedRow == -1">
                                    <i v-if="activeSortColumn == 1 && activeSortDirection == 'asc'" 
                                        class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 1 && activeSortDirection == 'asc'}" 
                                        size="lg" @click="sortColumn(1, 'desc')"></i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn == 1 && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                        size="lg" @click="sortColumn(1, 'asc')"></i>
                                </span>
                            </th>
                            <th class="text-right">
                                Credit Limit GBP
                                <span v-if="selectedRow == -1">
                                    <i v-if="activeSortColumn == 2 && activeSortDirection == 'asc'" 
                                        class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 2 && activeSortDirection == 'asc'}" 
                                        size="lg" @click="sortColumn(2, 'desc')"></i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn == 2 && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                        size="lg" @click="sortColumn(2, 'asc')"></i>
                                </span>
                            </th>
                            <th class="text-right">
                                Payment Terms
                                <span v-if="selectedRow == -1">
                                    <i v-if="activeSortColumn == 3 && activeSortDirection == 'asc'" 
                                        class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 3 && activeSortDirection == 'asc'}" 
                                        size="lg" @click="sortColumn(3, 'desc')"></i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn == 3 && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                        size="lg" @click="sortColumn(3, 'asc')"></i>
                                </span>
                            </th>
                            <th v-if="!isPricingEngineEnabled" class="text-right">
                                Premium (ppl)
                                <span v-if="selectedRow == -1">
                                    <i v-if="activeSortColumn == 4 && activeSortDirection == 'asc'" 
                                        class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 4 && activeSortDirection == 'asc'}" 
                                        size="lg" @click="sortColumn(4, 'desc')"></i>
                                    <i v-else class="fas sort-icon" 
                                        :class="activeSortColumn == 4 && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                        size="lg" @click="sortColumn(4, 'asc')"></i>
                                </span>    
                            </th>
                            <th class="text-center">Show Ex-rack</th>
                            <th class="text-center">Show Bunkering</th>
                            <th class="text-center">Show Delivered In</th>
                            <th class="text-center">Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(buyer, key) in buyers" :key="key"
                            :class="{'pb-2 pt-1' : $breakpoint.mdAndDown }"
                        >
                            <th
                                label="Buyer"
                                :class="{'heading-medium' : $breakpoint.smAndDown}"
                            >
                                {{buyer.name}}
                            </th>
                            <td label="Credit Limit" class="text-right">
                                <span v-if="buyer.credit">£{{buyer.credit.limit | priceformat}}</span>
                                <span v-else>N/A</span>
                            </td>
                            <td label="Payment Terms" class="text-right">
                                <span v-if="buyer.credit">{{buyer.credit.days | creditdaysformat}}</span>
                                <span v-else>N/A</span>
                            </td>
                            <template v-if="!isPricingEngineEnabled">
                                <td label="Premium" class="text-right"><span>{{buyer.premium | priceformat}}</span></td>
                            </template>
                            <td label="Show Bunkering" class="text-center">
                              <i v-if="buyer.enabled_spot" class="fas fa-circle text-primary"></i>
                              <i v-else class="fas fa-circle text-danger"></i>
                            </td>
                            
                            <td label="Show Bunkering" class="text-center">
                              <i v-if="buyer.enabled_bunkering" class="fas fa-circle text-primary"></i>
                              <i v-else class="fas fa-circle text-danger"></i>
                            </td>

                            <td label="Show Delivered In" class="text-center">
                              <i v-if="buyer.enabled_deliveredin" class="fas fa-circle text-primary"></i>
                              <i v-else class="fas fa-circle text-danger"></i>
                            </td>

                            <td class="text-center td-actions d-block">
                               <button class="btn btn-link" @click="openRelationshipManagement(buyer)">
                                   <i class="fas fa-edit fa-lg"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import RelationshipManagement from '@/modals/RelationshipManagement.vue'

import breakpoint from '@/mixins/index';

const INDEX_CREDIT_LIMIT = 0;
const INDEX_PAYMENT_TERMS = 1;
const INDEX_PREMIUM = 2;

const ERROR_TIMEOUT_MS = 2000;


export default {
    components: {
      RelationshipManagement
      },
    mixins: [breakpoint],
    data(){
        return {
            searchInput: "",
            inputValues: {
                creditLimit: 0,
                creditDays: 0,
                premium: 0
            },
            selectedRow: -1,
            invalidCreditLimit: false,
            invalidCreditDays: false,
            invalidPremium: false,
            activeSortColumn: 1,
            activeSortDirection: 'asc',
            showRelationshipManagement: false,
            relationship: null
        }
    },
    created() {
        this.getRelationships();
    },
    computed: {
        ...mapState('accounts', ['customerList']),
        ...mapState('inputCheckers',['numeral', 'numeralPositive']),
        ...mapState('login', ['userLoggedIn']),
        ...mapGetters("login", ["isPricingEngineEnabled"]),
        ...mapState("login", ["userLoggedIn"]),
        buyers: {
            get: function(){
                if (this.searchInput){
                    const inputValue = this.searchInput.toLowerCase()
    
                    /* Filter the list of connected buyers according to their names */
                    return this.customerList.filter(b => b.name.toLowerCase().indexOf(inputValue) > -1);
                } else {
                    return this.customerList;
                }
            }
        }
    },
    methods: {
        ...mapActions('accounts', ['getRelationships']),
        sortColumn: function(columnIndex, direction){
            let stringA = ''
            let stringB = ''
            this.activeSortDirection = direction
            this.activeSortColumn = columnIndex

            switch (columnIndex){
                case 1: // Sort by customer name
                    return this.buyers.sort((a, b) => {
                        stringA = a.name.toLowerCase()
                        stringB = b.name.toLowerCase()
                        
                        if (direction == 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 2: // Sort by credit limit
                {
                    let results = this.buyers.sort((a, b) => { 
                        let aCredit = a.credit ? a.credit.limit : 9007199254740991;
                        let bCredit = b.credit ? b.credit.limit : 9007199254740991;
                            
                        return aCredit - bCredit;
                    });
                    if (direction == 'desc')
                        results.reverse();                    
                    return results;
                }
                case 3: // Sort by credit days
                {
                    let results = this.buyers.sort((a, b) => { 
                        let aCredit = a.credit ? a.credit.days : 9007199254740991;
                        let bCredit = b.credit ? b.credit.days : 9007199254740991;
                        return aCredit - bCredit;
                    });
                    if (direction == 'desc')
                        results.reverse();                    
                    return results;
                }
                case 4: // Sort by premium
                {
                    return this.buyers.sort((a, b) => {
                        if (direction == 'asc'){
                            return a.premium - b.premium
                        }
                        else {
                            return b.premium - a.premium
                        }
                    })
                }
                default:
                    return
            }
        },
        openRelationshipManagement(buyer){
          this.relationship = buyer;
          this.showRelationshipManagement = true;
        },
        hideRelationshipManagement(){
          this.getRelationships();
          this.showRelationshipManagement = false;
        }
    }
}
</script>
